import React from "react";
import { View, StyleSheet, Platform } from "react-native";

import LottieView from "../../../components/CrossPlatformLottie";

interface ResultsConfettiOverlayProps {
  showConfetti: boolean;
  confettiLottie: any;
}

const ResultsConfettiOverlay: React.FC<ResultsConfettiOverlayProps> = ({ showConfetti, confettiLottie }) => {
  if (!showConfetti) return null;
  // pointerEvents cross-platform: see memory 05014c9a-a92e-4dc9-b6d8-bec8a1a98d2e
  // For React Native Web, pointerEvents must be in style; for native, as a prop
  const isWeb = Platform.OS === "web";
  const pointerEventsProp: 'auto' | 'none' | 'box-none' | 'box-only' | undefined = isWeb ? undefined : 'none';
  const pointerEventsStyle = isWeb ? { pointerEvents: "none" as const } : undefined;
  return (
    <View
      pointerEvents={pointerEventsProp}
      style={[StyleSheet.absoluteFillObject, { zIndex: 0 }, pointerEventsStyle]}
    >
      <LottieView
        source={confettiLottie}
        autoPlay
        loop={false}
        style={{ width: "100%", height: "100%" }}
      />
    </View>
  );
};

export default ResultsConfettiOverlay;
